const DEFAULT_LANGUAGE = 'en';
const createConfig = (language) => ({
    lng: language,
    resources: {
        [language]: {
            translation: require(`../locale/messages_en.json`),
        },
    },
});
export const getTranslationFunction = async (i18n, language = DEFAULT_LANGUAGE) => {
    const i18nInstance = i18n.createInstance();
    return i18nInstance.init(createConfig(language));
};
//# sourceMappingURL=i18n.js.map